import * as React from "react";
import { MapPin, Phone, Clock, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function UbicacionYContacto() {
  const contactDetails = [{
    icon: MapPin,
    title: "Headquarters",
    description: "436 South Rd, High Point, NC 27262"
  }, {
    icon: Phone,
    title: "Direct Line",
    description: "(336) 885-3045"
  }, {
    icon: Clock,
    title: "Operations",
    description: "Mon - Fri: 8:00 AM - 5:00 PM"
  }, {
    icon: Mail,
    title: "Email",
    description: "info@abcosouth.com"
  }];
  return <section data-section-id="227211" id="connect-with-us" className="bg-background text-foreground py-16 md:py-24 border-t border-border">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 md:gap-8 lg:gap-16 items-start">
          
          {}
          <div className="flex flex-col justify-center">
            <h2 className="font-serif text-5xl font-normal tracking-tight text-primary sm:text-6xl mb-8">Connect With <br />ABCO South</h2>
            
            <div className="space-y-6 mb-8">
              {contactDetails.map((detail, i) => {
              const Icon = detail.icon;
              return <div data-index={i} key={i} className="flex items-start gap-4">
                    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary/5 border border-primary/10">
                      {Icon ? <Icon className="h-5 w-5 text-primary" aria-hidden="true" /> : <div className="h-5 w-5" aria-hidden="true" />}
                    </div>
                    <div>
                      <h3 className="font-default text-lg font-bold text-foreground uppercase tracking-wider">
                        {detail.title}
                      </h3>
                      <p className="mt-1 text-base text-muted-foreground font-default">
                        {detail.description}
                      </p>
                    </div>
                  </div>;
            })}
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="w-full sm:w-auto text-base font-default font-semibold rounded-md bg-primary hover:bg-secondary transition-colors shadow-sm">
                <Link to="tel:+13368853045"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-phone mr-2 h-5 w-5" aria-hidden="true"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>Speak with an ABCO Expert</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="w-full h-full min-h-[400px] rounded-md overflow-hidden border border-border bg-muted">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/image001.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/image001.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/image001.jpg-wvc-sizes" alt="ABCO South Electrical Construction and Design North Carolina" className="w-full h-full object-cover" loading="lazy" decoding="async" />
          </div>

        </div>
      </div>
    </section>;
}